import React from 'react';

const MagicSignIcon = ({ colour = '#6021B3', width = '24', height = '24' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 17C9 17 9.7515 14.093 10.5 14.093C11.2485 14.093 12.105 17 12.75 17C13.395 17 13.5525 15.8372 14.25 15.8372C14.9475 15.8372 15.096 17 15.75 17C16.404 17 18 15.8372 18 15.8372M9 6H18M9 8.56977H18M9 11.186H18"
                stroke={colour}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.6818 2H7.31818C6.03789 2 5 2.80589 5 3.8V18.2C5 19.1941 6.03789 20 7.31818 20H19.6818C20.9621 20 22 19.1941 22 18.2V3.8C22 2.80589 20.9621 2 19.6818 2Z"
                stroke={colour}
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default MagicSignIcon;
